<template>
    <loading-block v-if="dataIsLoading"></loading-block>
    <div v-else>
        <loading-block v-if="dataIsLoading"></loading-block>
        <section v-else>
            <div>
                <h1>Options</h1>
            </div>
            <div>
                <p>Année en cours : {{this.currentYear.name}}</p>
                <uni-loading-button style="margin-bottom: 16px;" @click.native="openArchiveModal = true"
                                    text="Archiver l'année"></uni-loading-button>



                <h3>Dates d'inscription</h3>
                <p v-if="isSubscriptionOpen">Les inscriptions sont actuellement ouvertes</p>
                <p v-else>Les inscriptions sont actuellement fermées</p>
                <p>Du
                    <input type="date" v-model="date_from">
                    au
                    <input type="date" v-model="date_to">
                </p>

                <h3>Bandeau d'information</h3>
                <p>Bandeau bleu visible par les adhérents sur la page d'acceuil lors des inscriptions.</p>
                <uni-text-area placeholder="informations par rapport aux dates de permanence"
                               v-model="inscription_message"></uni-text-area>

                <p v-if="!isMobile" style="margin-top: 1rem;">Rendu du bandeau :</p>
                <rich-card class="infos" v-if="!isMobile">
                    <template slot="header">
                        <strong>Les inscriptions {{new Date().getFullYear()}} sont ouvertes !</strong>
                    </template>
                    <template slot="content">
                        {{inscription_message}}
                    </template>
                </rich-card>
                <uni-loading-button @click.native="saveOptions" :is-disable="optionLoader"
                                    text="Sauvegarder"></uni-loading-button>


            </div>
        </section>
        <pop-from-bottom :open="openArchiveModal"
                         title="Confirmation de l'archivage"
                         @close="openArchiveModal = false"
        >
            <template slot="content">
                <p>Êtes-vous sûr de vouloir archiver l'année ?</p>
                <uni-loading-button style="margin-bottom: 16px;" @click.native="archiveYear"
                                    text="Archiver l'année" :is-disable="archiveLoader"></uni-loading-button>
            </template>
        </pop-from-bottom>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'

    import LoadingBlock from "../../components/c-blocks/LoadingBlock";
    import UserInline from "../../components/b-patterns/userInline";
    import UniButton from "../../components/a-elements/UniButton";
    import PopFromBottom from "../../components/c-blocks/PopFromBottom";
    import UniInputContainer from "../../components/a-elements/UniInputContainer";
    import UniInput from "../../components/a-elements/UniInput";
    import InputBirthday from "../../components/a-elements/InputBirthday";
    import RichYesNoInput from "../../components/a-elements/RichYesNoInput";
    import UniInputRadio from "../../components/a-elements/UniInputRadio";
    import DuoInput from "../../components/b-patterns/DuoInput";
    import AdminInline from "../../components/b-patterns/adminInline";
    import UniTextArea from "../../components/a-elements/uniTextArea";
    import RichCard from "../../components/a-elements/RichCard";
    import UniLoadingButton from "../../components/b-patterns/UniLoadingButton";

    export default {
        name: "adminOptions",
        components: {
            UniLoadingButton,
            RichCard,
            UniTextArea,
            AdminInline,
            DuoInput,
            UniInputRadio,
            RichYesNoInput,
            InputBirthday, UniInput, UniInputContainer, PopFromBottom, UniButton, UserInline, LoadingBlock
        },
        computed: {
            ...mapGetters({isSubscriptionOpen: 'isSubscriptionOpen', currentYear: 'currentYear'}),

        },
        data() {
            return {
                archiveLoader: false,
                dataIsLoading: true,
                inscription_message: '',
                date_from: '',
                date_to: '',
                isMobile: false,
                optionLoader: false,
                openArchiveModal: false,

            }
        },
        methods: {
            archiveYear() {
              this.archiveLoader = true

                this.$http.get('/admin/families/archive-year')
                .then(res => {
                    let currentYear = res.data
                    this.$store.dispatch('setCurrentYear', currentYear)

                    this.archiveLoader = false
                    this.openArchiveModal = false
                })
                .catch(err => {
                    if (this.$isSignatureExpired(err.response.data.message)) {
                        this.$store.dispatch('logout')
                        this.$router.push({name: 'Login', params: {q: 'expired'}})
                    }
                })
            },
            renderDate(str) {
                let year, month, days, date
                date = new Date(str)
                year = date.getFullYear()
                days = date.getDate() < 10 ? "0" + date.getDate() : date.getDate()
                month = (date.getMonth() + 1) < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)


                return `${year}-${month}-${days}`
            },
            isUserOnMobile() {
                const width = window.innerWidth || document.documentElement.clientWidth ||
                    document.body.clientWidth
                this.isMobile = width < 768
            },
            saveOptions() {
                let obj = {
                    inscription_message: this.inscription_message,
                    date_from: this.date_from,
                    date_to: this.date_to
                }
                this.optionLoader = true
                this.$http.put('/options/1', {option: obj})
                    .then(response => {
                        this.optionLoader = false
                        this.$store.dispatch('updateSubscription', this.$isDateInRange(response.data.date_from, response.data.date_to))
                    })
                    .catch(error => {
                        if (this.$isSignatureExpired(error.response.data.message)) {
                            this.$store.dispatch('logout')
                            this.$router.push({name: 'Login', params: {q: 'expired'}})
                        }
                    })
            }
        },
        async created() {
            let response = await this.axios.get('/options/1')
            this.inscription_message = response.data.inscription_message
            this.date_to = this.renderDate(response.data.date_to)
            this.date_from = this.renderDate(response.data.date_from)

            this.isUserOnMobile()


            this.$nextTick(() => {
                this.dataIsLoading = false
            })
        }
    }
</script>

<style scoped lang="scss">

    section {
        > div:first-child {
            margin-bottom: 1rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }

    .infos {
        background: var(--color-primary);
        color: white;
        margin-bottom: 24px;

        strong {
            color: white;
        }
    }

    input {
        margin: 1rem 0.5rem 0;
        outline: none;
        border: 1px solid var(--color-grey-light-1);
        padding: 6px var(--s-xs);
        font-size: 1rem;
        line-height: 1rem;
        border-radius: var(--radius-default);
        transition: var(--transition-quick);
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
        background: none;
        color: var(--color-accent);

        &.invalid {
            border: 1px solid var(--color-warning);

            &:focus, &:hover {
                border: 1px solid var(--color-warning);
            }
        }

        &::placeholder {
            opacity: .5;
            color: var(--color-typo);
            font-size: 1rem;
            line-height: 1rem;
        }

        &:hover {
            border: 1px solid var(--color-primary-light-1);
        }

        &:focus {
            border: 1px solid var(--color-primary);
        }
    }

</style>
